import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Divider, Tooltip } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { ReactComponent as NewListingSvg } from 'assets/svg/Main/Overview-Number-clock.svg';
import { ReactComponent as CompetitorListingSvg } from 'assets/svg/Main/Overview-Number-listing.svg';
import { ReactComponent as TotalCompetitorsSvg } from 'assets/svg/Main/Overview-Number.svg';
import { ReactComponent as PercentIncreaseSvg } from 'assets/svg/Main/Percent-Increasing.svg';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import usePropertiesStore from 'store/usePropertiesStore';
import useUserStore from 'store/useUserStore';
import styled from 'styled-components';
import { formatNumber } from 'util/Funcs';

const CustomInfoCard = styled.div`
    display: flex;
    gap: 12px;
    padding: 14px;
    height: 84px;
    align-items: center;
    border-radius: 10px;
    box-shadow: 0px 0px 16px -4px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    background-color: #fff;
`;

interface InfoCardProps {
    icon: React.ComponentType;
    label: string;
    value: number;
    isLoading: boolean;
    totalProperties?: number;
    'data-cy'?: string;
}

const InfoCard = React.memo(({ icon: Icon, label, value, isLoading, totalProperties, 'data-cy': dataCy }: InfoCardProps) => (
    <CustomInfoCard>
        <div className="rounded-[10px] border bg-my-blue bg-opacity-10 border-my-blue p-[12px]">
            <Icon />
        </div>
        <div className="flex flex-col justify-between h-full flex-grow" data-cy={dataCy}>
            <div className="font-medium">{label}</div>
            <div className="flex items-end justify-between">
                <div className="font-semibold text-my-blue text-[24px]">{isLoading ? <Skeleton className="h-full w-[70px]" /> : formatNumber(value)}</div>
                {/* {label === 'Your Listings' && totalProperties !== undefined && (
                    <Tooltip
                        title='If you have fewer listings than the total, new partners might have been added or you have to upgrade your account. Check the "Partners" tab to add them and see all istings of hello:here'
                        arrow
                        placement="top"
                    >
                        <div className="text-my-blue text-[12px] flex items-center gap-[2px] bg-my-blue bg-opacity-10 px-2 py-1 rounded cursor-help">
                            <span>Total hello:here: {isLoading ? <Skeleton className="h-full w-[40px]" /> : formatNumber(totalProperties)}</span>
                            <InfoOutlinedIcon className="!text-[14px]" />
                        </div>
                    </Tooltip>
                )} */}
            </div>
        </div>
    </CustomInfoCard>
));

const InfoPanel = () => {
    const { userInfo: user } = useUserStore();
    const { propertyStatistics, fetchPropertiesStatistics } = usePropertiesStore();

    const { isLoading, error, isError, isRefetching } = useQuery({
        queryKey: ['fetchPropertiesStatistics'],
        queryFn: fetchPropertiesStatistics,
        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false,
    });

    if (isError) {
        return <div>{error.message}</div>;
    }

    return (
        <div className="pt-[5px] grid lg:grid-cols-3 md:grid-cols-2 gap-[16px]">
            <InfoCard
                icon={TotalCompetitorsSvg}
                label="Collaboration Partners"
                value={user?.savedCompetitors.length || 0}
                isLoading={isLoading || isRefetching}
                data-cy="total-competitors"
            />

            <InfoCard
                icon={CompetitorListingSvg}
                label="Total Listings"
                value={propertyStatistics.propertiesOn}
                totalProperties={propertyStatistics.totalProperties}
                isLoading={isLoading || isRefetching}
                data-cy="competitor-listings"
            />
            <InfoCard
                icon={NewListingSvg}
                label="New Listings Last 7 Days"
                value={propertyStatistics.propertiesAddedLast24Hours}
                isLoading={isLoading || isRefetching}
                data-cy="new-listing"
            />
            {/* TODO: database needs to be adjusted to get the correct value */}
            {/* <InfoCard
            icon={UnlistedSvg}
            label="Unlisted Properties last 30 days"
            value={propertyStatistics.propertiesOff}
            isLoading={isLoading || isRefetching}
            data-cy="unlisted-properties"
        /> */}
        </div>
        // <div className="rounded-[10px] bg-white leading-[24px] border border-my-gray border-opacity-60 ">
        // {/* percent */}
        // {/* <div className="p-[16px] flex justify-end">
        //     <div className="flex items-center flex-wrap gap-[5px] text-my-blue bg-my-blue bg-opacity-10 md:h-[30px] md:justify-normal justify-end px-[16px] rounded-[5px] font-medium">
        //         <span>{'hello:data Property Listings '}</span>
        //         <PercentIncreaseSvg />
        //         <div>
        //             {isLoading ? (
        //                 <Skeleton className="h-full w-[60px]" />
        //             ) : (
        //                 <span>{`${formatNumber(propertyStatistics.totalProperties)} (${formatNumber(propertyStatistics.totalPrecentSinceYesterday)}%)`}</span>
        //             )}
        //         </div>
        //     </div>
        // </div>

        // <Divider className="w-full" /> */}
        // </div>
    );
};

export default InfoPanel;
